import React from "react";
import moment from "moment";

import { bindActionCreators } from "redux";
import { withAlert } from "react-alert";
import { connect } from "react-redux";
import isEmpty from "lodash/isEmpty";
import Validator from "validator";
import SignatureComponent from "./signatureComponentPartner";

import { getAllSitePages, getPageDataFooter,getAllPlans } from "../../Actions/actions";

class TermsAndCondition extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorsTermPolicy: {},
      readDisclaimer: "",
      readPrivacyPolicy: "",
      readLetterOfAgency: "",
      readUserAgreement: "",
      // intervalId: 0,
      termsDataState: {},
      modalIsOpenSignature: false
    };
    this.handleSubmitTermPolicy = this.handleSubmitTermPolicy.bind(this);
    this.moveBack = this.moveBack.bind(this);
    this.AckOnchange = this.AckOnchange.bind(this);
  }

  handleSubmitTermPolicy() {
    // if (this.isValidTermPolicy()) {
    
    this.props.termsAndConditionDataNextPage();
    // }
    // const intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    // this.setState({ intervalId });
  }

  // scrollStep = () => {
  //     if (window.pageYOffset === 0) {
  //         clearInterval(this.state.intervalId);
  //     }
  //     window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  // }

  componentWillMount() {
    if (this.props.pageType === "consumer") {
      this.props.getPageDataFooter(6);
    }
    if (this.props.pageType === "business") {
      this.props.getPageDataFooter(7);
    }
  }

  moveBack() {
    this.props.termsAndConditionBack();
  }

  isValidTermPolicy() {
    const {
      errorsTermPolicy,
      isValidTermPolicy
    } = this.validateInputTermPolicy(this.state);

    if (!isValidTermPolicy) {
      this.setState({ errorsTermPolicy });
    }
    return isValidTermPolicy;
  }

  validateInputTermPolicy(data) {
    const { fileData } = this.props;
    const errorsTermPolicy = {};
    if (Validator.isEmpty(data.readDisclaimer)) {
      errorsTermPolicy.readDisclaimer = "Required";
      errorsTermPolicy.readDisclaimerError = true;
    }

    if (Validator.isEmpty(data.readPrivacyPolicy)) {
      errorsTermPolicy.readPrivacyPolicy = "Required";
      errorsTermPolicy.readPrivacyPolicyError = true;
    }

    if (Validator.isEmpty(data.readLetterOfAgency)) {
      errorsTermPolicy.readLetterOfAgency = "Required";
      errorsTermPolicy.readLetterOfAgencyError = true;
    }

    if (Validator.isEmpty(data.readUserAgreement)) {
      errorsTermPolicy.readUserAgreement = "Required";
      errorsTermPolicy.readUserAgreementError = true;
    }
    // console.log('fileData', fileData)

    if (fileData === "") {
      errorsTermPolicy.readUserAgreementFile = "Required";
      errorsTermPolicy.readUserAgreementErrorFile = true;
    }
    return {
      errorsTermPolicy,
      isValidTermPolicy: isEmpty(errorsTermPolicy)
    };
  }

  AckOnchange(e) {
    // const name = e.target.name;
    // let value = '';
    this.props.termsAndConditionData(e.target.name, e.target.checked);
    // const {
    //   readDisclaimer, readPrivacyPolicy, bankAccount, serviceFeeAgree, readLetterOfAgency, readUserAgreement,
    // } = this.state;
    // if (name === 'readDisclaimer' && e.target.checked === true) {
    //     value = '1';
    // }
    // if (name === 'readPrivacyPolicy' && e.target.checked === true) {
    //     value = '1';
    // }
    // if (name === 'readLetterOfAgency' && e.target.checked === true) {
    //     value = '1';
    // }
    // if (name === 'readUserAgreement' && e.target.checked === true) {
    //     value = '1';
    // }
    // if (name === 'bankAccount' && e.target.checked === true) {
    //     value = '1';
    // }
    // if (name === 'serviceFeeAgree' && e.target.checked === true) {
    //     value = '1';
    // }
    // this.setState({ [e.target.name]: value}, () => {

    // });
  }

  closeSignatureModal = () => {
    this.setState({
      modalIsOpenSignature: false
    });
  };

  componentDidMount() {
    this.props.getAllPlans({
      pageNumber: 0,
      pageSize: 20,
      searchKeyword: '',
      planUserType: 'Business',
      userId: 0,
      affiliateKey: this.props.data.plansDataAffiliate.result && this.props.data.plansDataAffiliate.result.affiliateSubscriptionDto.affiliateKey !== undefined
          ? this.props.data.plansDataAffiliate.result.affiliateSubscriptionDto.affiliateKey
          : '',
    });
  }
  //
  // componentDidUpdate() {
  //     const { termsDataState } = this.state;
  //     const { signupData  } = this.props;
  //       if (termsDataState !== signupData) {
  //         this.setState({
  //           termsDataState: signupData,
  //           readDisclaimer: signupData.readDisclaimer,
  //           readPrivacyPolicy: signupData.readPrivacyPolicy,
  //           readLetterOfAgency: signupData.readLetterOfAgency,
  //           readUserAgreement: signupData.readUserAgreement,
  //         });
  //     }
  //   }
  //     handleSaveDataNext = () =>{

  //     const {
  //         readDisclaimer, readUserAgreement, readPrivacyPolicy, readLetterOfAgency,
  //     } = this.state;
  //         this.props.termsAndConditionData({
  //             readDisclaimer, readUserAgreement, readPrivacyPolicy, readLetterOfAgency,
  //         });

  // }

  render() {
    const { errorsTermPolicy, modalIsOpenSignature } = this.state;
    const { pageDetailsFooter } = this.props.data;
    const {
      defaultValue,
      fontFamily,
      isConsumer,
      makepayment,
      fileImage,
      fileData,
      moveTop,
      readDisclaimer,
      readUserAgreement,
      readPrivacyPolicy,
      readLetterOfAgency,
      selectedPlanAmount,
      hideBack,
    } = this.props;
    console.log('this.props!!!!!!!!!!!!', this.props)
    // console.log('selectedPlanAmount', selectedPlanAmount)
    return (
      <div className="signup-tab-align">
        <div
          id="legal-tab"
          className="col s12 main-content signup-new-tabs-content ibmfont"
        >
          <div className="tab-inner step4">

            <SignatureComponent
              defaultValue={defaultValue}
              fontFamily={fontFamily}
              // finalSubmitData={finalSubmitData}
              fileImage={fileImage}
              signupData={this.state}
              moveTop={moveTop}
              fileData={fileData}
              hide
              modalIsOpen={modalIsOpenSignature}
              closeSignatureModal={this.closeSignatureModal}
            />

            <div className="legal-stuff">
              <div className="legal-stuff-hdr">
                <h4 className="center-align signup-title">The Legal Stuff</h4>
                <p className="center-align  font-medium">
                  Collectively monitors, files and helps you collect from antitrust
                  and class action settlements.
                  </p>
                <p className="center-align  font-medium"> In order for us to be able to act on
                your behalf, we need you to agree to the following
          </p>
              </div>
              <div className="row">
                {/* <div className="col s12 legal-stuff-checkouter">
                            <label>
                                <input type="checkbox" checked="checked" />
                                <span>I have read and agree to the <a href="javascript:;" className="text-700">Service Agreement</a> The user Agreement states the term on which Collectively will provide services.</span>
                            </label>
                        </div> */}
                <div className="col s12 legal-stuff-checkouter">
                  <label>
                    <input
                      type="checkbox"
                      name="readUserAgreement"
                      onChange={this.AckOnchange}
                      value="1"
                      checked={readUserAgreement === "1"}
                    />
                    <span>
                      I have read and agree to the{" "}
                      <a href="/user-agreement" target="_blank">
                        Service Agreement
                  </a>
                    </span>
                  </label>
                  <span
                    className={
                      errorsTermPolicy.readUserAgreementError
                        ? "show invalid"
                        : "hide"
                    }
                  >
                    {errorsTermPolicy.readUserAgreement}
                  </span>
                  <p className="des legal-des font-medium">
                    The User Agreement states the terms on which Collectively will
                    provide services.
              </p>
                </div>

                <div
                  className={
                    readUserAgreement === "1"
                      ? "col s12 legal-stuff-checkouter"
                      : "col s12 legal-stuff-checkouter disable-aggrement"
                  }
                >
                  <label>
                    <input
                      type="checkbox"
                      name="readLetterOfAgency"
                      onChange={this.AckOnchange}
                      value="1"
                      checked={readLetterOfAgency === "1"}
                    />
                    <span>
                      I have read and agree to the{" "}
                      <a href="/revocable-letter-of-agency" target="_blank">
                        Revocable Letter of Agency and e-signature consent
                  </a>
                    </span>
                  </label>
                  <span
                    className={
                      errorsTermPolicy.readLetterOfAgencyError
                        ? "show invalid"
                        : "hide"
                    }
                  >
                    {errorsTermPolicy.readLetterOfAgency}
                  </span>
                  <p className="des legal-des font-medium">
                    The Revocable Letter of Agency appoints Collectively as your
                    agent for purposes of carrying out the provisions of the
                    Customer Agreement and taking any actions Collectively deems
                    necessary or advisable to accomplish the purposes of the
                    Customer Agreement. The Revocable Letter of Agency is part of
                    the Customer Agreement and subject to its terms.
              </p>
                </div>

                <div
                  className={
                    readUserAgreement === "1" && readLetterOfAgency === "1"
                      ? "col s12 legal-stuff-checkouter"
                      : "col s12 legal-stuff-checkouter disable-aggrement"
                  }
                >
                  <label>
                    <input
                      type="checkbox"
                      name="readPrivacyPolicy"
                      onChange={this.AckOnchange}
                      value="1"
                      checked={readPrivacyPolicy === "1"}
                    />
                    <span>
                      I have read and agree to the{" "}
                      <a
                        href="https://www.collectivelyapp.com/privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Privacy Policy
                  </a>
                    </span>
                  </label>
                  <span
                    className={
                      errorsTermPolicy.readPrivacyPolicyError
                        ? "show invalid"
                        : "hide"
                    }
                  >
                    {errorsTermPolicy.readPrivacyPolicy}
                  </span>
                </div>

                <div
                  className={
                    readUserAgreement === "1" &&
                      readLetterOfAgency === "1" &&
                      readPrivacyPolicy === "1"
                      ? "col s12 legal-stuff-checkouter"
                      : "col s12 legal-stuff-checkouter disable-aggrement"
                  }
                >
                  <label>
                    <input
                      type="checkbox"
                      name="readDisclaimer"
                      onChange={this.AckOnchange}
                      value="1"
                      checked={readDisclaimer === "1"}
                    />
                    <span>I have read and agree to the disclaimer below</span>
                  </label>
                  <span
                    className={
                      errorsTermPolicy.readDisclaimerError ? "show invalid" : "hide"
                    }
                  >
                    {errorsTermPolicy.readDisclaimer}
                  </span>
                  <div className="des legal-des font-medium ">
                    {pageDetailsFooter !== undefined ? (
                      pageDetailsFooter.body !== undefined ? (
                        <p dangerouslySetInnerHTML={{ __html: pageDetailsFooter.body }} />
                      ) : (
                          <p>
                            Collectively is not a law firm and does not give legal
                            advice. Collectively is not associated with the class
                            administrator, the court, class counsel or any other
                            official parties. You do not have to hire a third-party
                            claims consultant and are entitled to file your claim on
                            your own without incurring any fee. For The Payment Card
                            Settlement Only: The Second Circuit Court of Appeals
                            reversed approval of the settlement and returned the case
                            to the District Court on June 30, 2016. Litigation is
                            ongoing. No claim forms are available at this time, and no
                            claim-filing deadline exists. If another settlement is
                            reached, no-cost assistance will be available from the
                            Class Administrator and Class Counsel during any
                            claims-filing period. No one is required to sign up with
                            any third-party service in order to participate in any
                            settlement. For additional information regarding the
                            status of the litigation, interested persons may visit
                            www. paymentcardsettlement.com the Court-approved website
                            for this case.
                    </p>
                        )
                    ) : (
                        <p>
                          Collectively is not a law firm and does not give legal
                          advice. Collectively is not associated with the class
                          administrator, the court, class counsel or any other
                          official parties. You do not have to hire a third-party
                          claims consultant and are entitled to file your claim on
                          your own without incurring any fee. For The Payment Card
                          Settlement Only: The Second Circuit Court of Appeals
                          reversed approval of the settlement and returned the case to
                          the District Court on June 30, 2016. Litigation is ongoing.
                          No claim forms are available at this time, and no
                          claim-filing deadline exists. If another settlement is
                          reached, no-cost assistance will be available from the Class
                          Administrator and Class Counsel during any claims-filing
                          period. No one is required to sign up with any third-party
                          service in order to participate in any settlement. For
                          additional information regarding the status of the
                          litigation, interested persons may visit www.
                          paymentcardsettlement.com the Court-approved website for
                          this case.
                  </p>
                      )}
                  </div>
                </div>

                <div
                  className={
                    readUserAgreement === "1" &&
                      readLetterOfAgency === "1" &&
                      readPrivacyPolicy === "1" &&
                      readDisclaimer === "1"
                      ? "col s12 legal-stuff-checkouter grey-bdr"
                      : "col s12 legal-stuff-checkouter grey-bdr disable-aggrement"
                  }
                >
                  {fileData === "" ? (
                    <div>
                      <p className="create-esignature font-medium font-18 mb-none">
                        Setup a Signature for Claims
                  </p>
                      <button
                        className={
                          readUserAgreement === "1" &&
                            readLetterOfAgency === "1" &&
                            readPrivacyPolicy === "1" &&
                            readDisclaimer === "1"
                            ? "create-signature-blue create-esignature"
                            : " create-signature-ltgrey create-esignature"
                        }
                        // className="btn waves-effect waves-light btn-blue create-esignature"
                        type="submit"
                        name="action"
                        onClick={() => {
                          this.setState({
                            modalIsOpenSignature: true
                          });
                        }}
                      >
                        Create E-signature
                  </button>

                      <span
                        className={
                          errorsTermPolicy.readUserAgreementFile
                            ? "show invalid"
                            : "hide"
                        }
                      >
                        {errorsTermPolicy.readUserAgreementFile}
                      </span>
                    </div>
                  ) : (
                      <div className="adop-signature draW-sign">
                        <div className="signature-box">
                          <img src={fileData} alt="sinagture" />{" "}
                          <a
                            className="edit"
                            onClick={() => {
                              this.setState({
                                modalIsOpenSignature: true
                              });
                            }}
                          >
                            Edit
                    </a>
                        </div>{" "}
                        <div className="signature-date">
                          {moment().format("MM/DD/YYYY")}
                        </div>
                      </div>
                    )}
                  {fileData !== "" ? (
                    <p className="col s12 signature-text">SIGNATURE</p>
                  ) : (
                      ""
                    )}
                  {fileData !== "" ? (
                    <p className="col s12 agree2signature">
                      I agree that this is my signature and I agree this is a legal
                      representation of my signature for all purposes just the same
                      as a pen-and-paper signature
                </p>
                  ) : (
                      ""
                    )}

                  {fileData !== "" ? (
                    <div className="col s12 legal-stuff-checkouter pb-none">
                      <p className="draW-sign font-medium">
                        After your account is created, you will be able to view and
                        download your signed documents from the My Profile
                        management page.
                  </p>
                    </div>
                  ) : (
                      ""
                    )}
                </div>

                <div className="grey-bdr" />
                <div className="col s12 center-align input-field claimant-btns checkout-btns">

                 {hideBack ? '' : ( <a
                    className=" waves-effect waves-light white-btn back-button back-btn-pad-mob"
                    onClick={this.moveBack}
                  >
                    Back
                 </a>)}

                  <button
                    className={
                      readUserAgreement === "1" &&
                        readLetterOfAgency === "1" &&
                        readPrivacyPolicy === "1" &&
                        readDisclaimer === "1" &&
                        fileData !== "" &&
                        (!makepayment ? selectedPlanAmount !== "" : true)
                        ? "waves-effect waves-light pink-btn make-payment-button"
                        : "waves-effect waves-light ltgrey-btn make-payment-action"
                    }
                    disabled={
                      readUserAgreement === "1" &&
                        readLetterOfAgency === "1" &&
                        readPrivacyPolicy === "1" &&
                        readDisclaimer === "1" &&
                        fileData !== "" &&
                        (!makepayment ? selectedPlanAmount !== "" : true)
                        ? false
                        : true
                    }
                    type="submit"
                    name="action"
                    onClick={() => {
                      this.handleSubmitTermPolicy();
                    }}
                  >
                    {isConsumer
                      ? "Complete Registration"
                      : makepayment
                        ? "Complete Registration"
                        : "Make Payment"}
                  </button>
                </div>
              </div>

              {/* <div className="row">
                        <div className="col s12 legal-stuff-checkouter">
                            <label>
                                <input type="checkbox" checked="checked" />
                                <span>I have read and agree to the <a href="javascript:;" className="text-700">Service Agreement</a> The user Agreement states the term on which Collectively will provide services.</span>
                            </label>
                        </div>
                        <div className="col s12 legal-stuff-checkouter">
                            <label>
                                <input type="checkbox" checked="checked" />
                                <span>I have read and agree to the <a href="javascript:;" className="text-700">Revocable Letter of Agency and e-signature consent</a> The Revocable Letter of Agency appoints Collectively as your agent for purposes of carrying out the provisions of the Customer Agreement and taking any actions Collectively deems necessary or advisable to accomplish the purposes of the Customer Agreement. The Revocable Letter of Agency is part of the Customer Agreement and subject to its terms.</span>
                            </label>
                        </div>
                        <div className="col s12 legal-stuff-checkouter ">
                            <label>
                                <input type="checkbox" checked="checked" />
                                <span>I have read and agree to the <a href="javascript:;" className="text-700">Privacy Policy</a></span>
                            </label>
                        </div>
                        <div className="col s12 legal-stuff-checkouter">
                            <label>
                                <input type="checkbox" checked="checked" />
                                <span>I have read and agree to the disclaimer below Disclaimer: Collectively is not a law firm and does not give legal advice. Collectively is not associated with the class administrator, the court, class counsel or any other official parties. You do not have to hire a third-party claims consultant and are entitled to file your claim on your own without incurring any fee. For The Payment Card Settlement Only: On January 24, 2019, the Court granted preliminary approval to the proposed settlement. No claim forms are available and no claims-filling deadline exists, at this time. Class members are not required to sign up for a third-party service in order to participate in any monetary relief. No-cost assistance will be available from the Class Administrator and Class Counsel during the claims-filling preiod. Additional information is available at www.paymentcardsettlement.com, the Court-approved website for this case. After your account is created, you will be able to view and download your signed documents from the My Profile management page.</span>
                            </label>
                        </div>

                        <div className="col s12 center-align">
                            <button className="btn waves-effect waves-light primary-btn white-btn" type="submit" name="action">Back
                            </button>
                            <button className="btn waves-effect waves-light primary-btn pink-btn" type="submit" name="action">Set Up E-Signature
                            </button>
                        </div>
                    </div> */}
            </div>

          </div>

        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  data: state.data
  // signupData: state.signupData,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getAllSitePages, getPageDataFooter,getAllPlans }, dispatch);

export default withAlert(
  connect(mapStateToProps, mapDispatchToProps)(TermsAndCondition)
);
